import { SectorFilterOptions } from "../enums";
import { Sector } from "./Sector";
import { SectorField } from "./SectorField";

export class SectorFilter {
    sectors: Sector[];

    constructor(sectors: string) {
        this.sectors = JSON.parse(sectors).map((sector: any) => new Sector(
            sector.sectorCode,
            sector.selection,
            sector.filters.map((filter: any) => new SectorField(filter.componentId, filter.name, filter.value))
        ));
    }

    addSector(sector: Sector) {
        this.sectors.push(sector);
    }

    removeSector(sectorCode: string) {
        this.sectors = this.sectors.filter(sector => sector.sectorCode !== sectorCode);
    }

    getSector(sectorCode: string): Sector {
        return this.sectors.find(sector => sector.sectorCode === sectorCode) as Sector;
    }

    setSectorFilterValue(sectorCode: string, componentId: string, name: string, value: string | number) {
        const sector = this.getSector(sectorCode);
        if (sector) {
            sector.setFilterValue(componentId, name, value);
        }
    }

    getSectorFilterValue(sectorCode: string, componentId: string): string | number | undefined {
        const sector = this.getSector(sectorCode);
        return sector ? sector.getFilterValue(componentId) : undefined;
    }

    isAtLeastOneSectorFilterActive(): boolean {
        if (this.sectors.filter(sector => (sector.selection === SectorFilterOptions.ALL || sector.selection === SectorFilterOptions.FILTER)).length === 0) {
            return false;
        }
        return true;
    }

    // if 'Filter' is selected on accordion, check if any filter is selected
    checkIfAnyFilterSelectionIsEmpty(): boolean {
        return this.sectors.some(sector => sector.selection === SectorFilterOptions.FILTER && sector.filters.length === 0);
    }

}